import type { Surface } from '@ampshift/shared';

export interface Turn {
  id: string;
  role: 'user' | 'assistant';
  text: string;
  surfaces: Surface[];
  inputMode?: 'text' | 'voice';
  status?: 'pending' | 'error';
  /** Generated locally (helper prompts), never sent to the API. */
  local?: boolean;
  at: number;
}

let counter = 0;
export function nextTurnId(): string {
  counter += 1;
  return `t${Date.now().toString(36)}-${counter}`;
}
